<div class="login-container auth-container">
  <div class="login-card auth-card">
    <h2>Login to Taptimize</h2>
    
    <form (ngSubmit)="onSubmit()" #loginForm="ngForm">
      <div class="form-group">
        <label for="email">Email</label>
        <input 
          type="email" 
          id="email" 
          name="email" 
          [(ngModel)]="loginData.email" 
          required 
          email
          class="form-control"
          placeholder="Enter your email">
      </div>

      <div class="form-group">
        <label for="password">Password</label>
        <input 
          type="password" 
          id="password" 
          name="password" 
          [(ngModel)]="loginData.password" 
          required
          class="form-control"
          placeholder="Enter your password">
      </div>

      <div class="error-message" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <button 
        type="submit" 
        [disabled]="!loginForm.valid || isLoading"
        class="btn-primary">
        <span *ngIf="isLoading">Logging in...</span>
        <span *ngIf="!isLoading">Login</span>
      </button>
    </form>

    <div class="register-link auth-link">
      <p>Don't have an account? <a href="/register" (click)="goToRegister($event)">Register here</a></p>
    </div>
  </div>
</div> 